import React, { useEffect, useRef,useState } from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import moment from "moment";

import pictoClose from "../assets/images/close.svg";
import pictoArrowLeft from "../assets/images/arrow-left-w.svg";
import {urlDirectus} from "../Map/config/globals";

export const SideBarEndMatiere = ({closeDetailMatiere, matiereCourante, setAndShowImage}) => {

    const [swiper, setSwiper] = useState(null);
    const nexto = () => {
        swiper.slideNext();
    };


    const [swiper2, setSwiper2] = useState(null);
    const nexto2 = () => {
        swiper2.slideNext();
    };
    return (
        matiereCourante &&
        <div id="side-bar-matiere" className={matiereCourante.stylecss ? matiereCourante.stylecss + " sidebar-end col-2 position-fixed end-0 top-0 py-4 pe-4 h-100" : " sidebar-end col-2 position-fixed end-0 top-0 py-4 pe-4 h-100 off" }>
            <div className="sidebar-content col-12 d-flex flex-column bg-white h-100 p-3 p-xl-4">
                <div className="sidebar-content-head d-flex flex-column pb-3 mb-4 border-bottom border-custom border-2">
                    <div className="d-flex align-items-center justify-content-start position-relative">
                        <div className="mini-popup-carte-picto rounded-3 ratio-11 d-flex align-items-center justify-content-center position-absolute start-0 overflow-hidden p-0">
                            {matiereCourante.photo && <img className="img-fluid w-100 h-100 object-fit-cover" src={urlDirectus + 'assets/'+matiereCourante.photo.id} />}
                        </div>
                        <div className="dotted-pattern dotted-pattern-custom dotted-pattern-simple"></div>
                        <div className="d-flex flex-column justify-content-center text-start lh-xs px-3">
                            <span className="fw-b fs-5">{matiereCourante.libelle}</span>
                        </div>
                        <button className="toggle-btn ms-auto" onClick={closeDetailMatiere}>
                            <img src={pictoClose} />
                        </button>
                    </div>
                    <div className="d-flex flex-wrap pt-3 d-none">
                        <span className="bg-light rounded-pill px-3 fs-7 me-2 mb-2">#Abattre</span>
                        <span className="bg-light rounded-pill px-3 fs-7 me-2 mb-2">#Débiter</span>
                    </div>
                </div>
                <div className="w-100 d-flex flex-column align-items-start pb-4">
                    <div className="table-popup table-custom w-100 d-flex flex-column align-items-start">
                        <div className="table-popup-onglet active text-uppercase fw-b fs-7 lh-lg px-2 rounded-top">Description</div>
                        <div className="table-popup-datas fs-7 px-2 py-1 w-100 rounded-3">
                            <div className="table-popup-row d-flex justify-content-between align-items-center border-bottom pb-1">
                                <span>Type</span><span className="text-muted text-spectral">{matiereCourante.type}</span>
                            </div>
                            <div
                                className="table-popup-row d-flex justify-content-between align-items-center border-bottom py-1">
                                <span>Couleur de référence</span><span className="text-muted text-spectral">{matiereCourante.couleur}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-100 d-flex align-items-center justify-content-between pb-4">
                    <div className="d-flex flex-column align-items-start">
                        <i className="fs-9 text-muted text-spectral ms-auto">Sources : {matiereCourante.source}</i>
                    </div>
                </div>


                <div className="w-100 d-flex flex-column align-items-start pb-4">
                    <div className="w-100 d-flex flex-column align-items-start">
                        <div className="w-100 d-flex align-items-center position-relative">
                            <span className="text-uppercase fw-b fs-7 lh-lg">{matiereCourante.libelle} en images</span>
                            <div className="dotted-pattern dotted-pattern-simple dotted-pattern-row opacity-25 flex-grow-1"></div>
                            <a className="swiper-button-mini swiper-button-next-documents bg-custom rounded-circle position-absolute end-0 flex-shrink-0" onClick={nexto} ><img className="img-fluid w-100 h-100 rotate180" src={pictoArrowLeft}/></a>
                        </div>
                        <div className="w-100 swiper-popup-documents overflow-hidden py-3">
                                {(() => {
                                    if (matiereCourante.images && matiereCourante.images.length > 0) {
                                        return (
                                            <>
                                            <Swiper slidesPerView={2.5} rebuildOnUpdate={true} direction="horizontal" loop={true} spaceBetween={15} speed={400} onSwiper={(s) => { setSwiper(s);}}
                                                    /*breakpoints={{
                                                        768: {
                                                            slidesPerView: 2,
                                                            spaceBetween: 24
                                                        },
                                                        992: {
                                                            slidesPerView: 3,
                                                            spaceBetween: 24
                                                        },
                                                        1400: {
                                                            slidesPerView: 2,
                                                            spaceBetween: 24
                                                        },
                                                    }}*/
                                                >
                                                {
                                                    matiereCourante.images.map((image, index) => {
                                                        return (
                                                            <SwiperSlide key={"swipperslide-"+image.id} className="swiper-slide">
                                                                <a onClick={()=> setAndShowImage('zoom',urlDirectus+'assets/'+image.item.image,image.item.libelle) } className="rounded-3 shadow-sm overflow-hidden position-relative d-flex text-decoration-none text-white ratio-11">
                                                                    <i className="nom-document w-100 mt-auto px-1 py-2 bg-custom position-relative z-1 text-spectral fs-8 text-center lh-sm"><span className="texte-clamp">{image.item.libelle}</span></i>
                                                                    <img className="position-absolute start-0 top-0 w-100 h-100 object-fit-cover z-0" src={urlDirectus+'assets/'+image.item.image} alt={image.item.libelle} />
                                                                </a>
                                                            </SwiperSlide>
                                                        )
                                                    })
                                                }

                                            </Swiper>
                                            </>
                                        );
                                    }else{
                                        return "Aucun document";
                                    }
                                })()}
                        </div>
                    </div>
                </div>

                <div className="w-100 d-flex flex-column align-items-start pb-4">
                    <div className="w-100 d-flex flex-column align-items-start">
                        <div className="w-100 d-flex align-items-center position-relative">
                            <span className="text-uppercase fw-b fs-7 lh-lg">Documents téléchargeables</span>
                            <div
                                className="dotted-pattern dotted-pattern-simple dotted-pattern-row opacity-25 flex-grow-1"></div>
                            <a className="swiper-button-mini swiper-button-next-autres bg-custom rounded-circle position-absolute end-0 flex-shrink-0"
                               onClick={nexto2}><img className="img-fluid w-100 h-100 rotate180"
                                              src={pictoArrowLeft}/></a>
                        </div>
                        <div className="w-100 swiper-popup-autres overflow-hidden py-3">
                                {(() => {
                                    if (matiereCourante.fichiers && matiereCourante.fichiers.length > 0) {
                                        return (
                                            <>
                                            <Swiper slidesPerView={2.5} rebuildOnUpdate={true} direction="horizontal" loop={true} spaceBetween={15} speed={400} onSwiper={(s) => { setSwiper2(s);}}
                                                    /*breakpoints={{
                                                        768: {
                                                            slidesPerView: 2,
                                                            spaceBetween: 24
                                                        },
                                                        992: {
                                                            slidesPerView: 3,
                                                            spaceBetween: 24
                                                        },
                                                        1400: {
                                                            slidesPerView: 2,
                                                            spaceBetween: 24
                                                        },
                                                    }}*/
                                                >
                                                {
                                                    matiereCourante.fichiers.map((fichier, index) => {
                                                        return (
                                                            <SwiperSlide key={"swipperslide-"+fichier.id} className="swiper-slide">
                                                                <a href={urlDirectus+'assets/'+fichier.item.fichier} target='_blank' className="rounded-3 shadow-sm overflow-hidden position-relative d-flex text-decoration-none text-white ratio-11">
                                                                    <i className="nom-document w-100 mt-auto px-1 py-2 bg-custom position-relative z-1 text-spectral fs-8 text-center lh-sm"><span className="texte-clamp">{fichier.item.libelle}</span></i>
                                                                    <img className="position-absolute start-0 top-0 w-100 h-100 object-fit-cover z-0" src={urlDirectus+'assets/'+fichier.item.vignette} alt={fichier.item.libelle} />
                                                                </a>
                                                            </SwiperSlide>
                                                        )
                                                    })
                                                }
                                            </Swiper>
                                            </>
                                        );
                                    }else{
                                        return "Aucun document";
                                    }
                                })()}
                        </div>
                    </div>
                </div>

                <div className="w-100 d-flex flex-column align-items-start pb-4">
                    <div className="w-100 d-flex flex-column align-items-start">
                        <div className="w-100 d-flex align-items-center position-relative">
                            <span className="text-uppercase fw-b fs-7 lh-lg">Bâtiments</span>
                            <div className="dotted-pattern dotted-pattern-simple dotted-pattern-row opacity-25 flex-grow-1"></div>

                        </div>
                        <div className="w-100 swiper-popup-autres overflow-hidden py-3">
                            <span className="badge bg-primary rounded-pill">Bientôt</span>
                        </div>
                    </div>
                </div>

                <div className="w-100 d-flex flex-column align-items-start pb-4">
                    <div className="w-100 d-flex flex-column align-items-start">
                        <div className="w-100 d-flex align-items-center position-relative">
                            <span className="text-uppercase fw-b fs-7 lh-lg">Chaînes opératoires</span>
                            <div className="dotted-pattern dotted-pattern-simple dotted-pattern-row opacity-25 flex-grow-1"></div>

                        </div>
                        <div className="w-100 swiper-popup-autres overflow-hidden py-3">
                            <span className="badge bg-primary rounded-pill">Bientôt</span>
                        </div>
                    </div>
                </div>


                <div className="dotted-pattern opacity-25 dotted-pattern-simple w-100 mt-auto"></div>
            </div>
        </div>
    )
}
